import { Pipe, PipeTransform } from '@angular/core';
import { AsYouType } from 'libphonenumber-js';

@Pipe({
  name: 'phoneFormat'
})
export class PhoneFormatPipe implements PipeTransform {

  transform(tel: any): any {
    if(!tel) return tel;
    
    // Clean up spaces and invalid characters before formatting
    const telStr = tel.toString().trim();
    const digits = telStr.replace(/[^\d+]/g, '');
    
    let country: any = 'US';
    if (digits.startsWith('0')) {
        country = 'VN';
    }
    
    const asYouType = new AsYouType(country);
    return asYouType.input(digits);
  }
}
